class InfiniteScroll {
  constructor() {
    console.log('[InfiniteScroll] Constructor called');
    this.observer = null;
    this.loading = false;
    this.scrollHandler = null;
    this.init();
    this.hookIntoFacets();
  }

  hookIntoFacets() {
    if (typeof FacetFiltersForm !== 'undefined') {
      console.log('[InfiniteScroll] FacetFiltersForm found, patching renderProductGridContainer');
      const originalRender = FacetFiltersForm.renderProductGridContainer;
      const self = this;
      FacetFiltersForm.renderProductGridContainer = function (html) {
        originalRender.call(this, html);
        console.log('[InfiniteScroll] Facets re-rendered grid, re-initializing');
        self.destroy();
        self.init();
      };
    } else {
      console.warn('[InfiniteScroll] FacetFiltersForm not found — facets hook skipped');
    }
  }

  init() {
    this.sentinel = document.getElementById('infinite-scroll-sentinel');
    console.log('[InfiniteScroll] init() — sentinel:', this.sentinel);

    if (!this.sentinel) {
      console.warn('[InfiniteScroll] No sentinel found. Either only 1 page of products or element missing.');
      return;
    }

    this.grid = document.getElementById('product-grid');
    this.spinner = document.getElementById('infinite-scroll-spinner');
    this.nextUrl = this.sentinel.dataset.nextUrl;
    this.sectionId = this.sentinel.dataset.sectionId;
    this.loading = false;

    console.log('[InfiniteScroll] nextUrl:', this.nextUrl);
    console.log('[InfiniteScroll] sectionId:', this.sectionId);

    // Try IntersectionObserver first
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          console.log('[InfiniteScroll] IntersectionObserver — isIntersecting:', entry.isIntersecting, 'ratio:', entry.intersectionRatio, 'boundingRect top:', entry.boundingClientRect.top, 'windowHeight:', window.innerHeight);
          if (entry.isIntersecting && !this.loading && this.nextUrl) {
            this.loadMore();
          }
        });
      },
      { rootMargin: '0px 0px 1000px 0px' }
    );
    this.observer.observe(this.sentinel);

    // Also use scroll listener as fallback
    this.scrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.scrollHandler, { passive: true });
    console.log('[InfiniteScroll] Observer + scroll listener attached');

    // Check immediately in case sentinel is already near viewport
    this.checkSentinelPosition();
  }

  checkSentinelPosition() {
    if (!this.sentinel || this.loading || !this.nextUrl) return;
    const rect = this.sentinel.getBoundingClientRect();
    const triggerPoint = window.innerHeight + 1000;
    console.log('[InfiniteScroll] checkSentinelPosition — sentinel top:', rect.top, 'triggerPoint:', triggerPoint, 'shouldLoad:', rect.top < triggerPoint);
    if (rect.top < triggerPoint) {
      this.loadMore();
    }
  }

  onScroll() {
    if (this.loading || !this.nextUrl || !this.sentinel) return;
    const rect = this.sentinel.getBoundingClientRect();
    if (rect.top < window.innerHeight + 1000) {
      console.log('[InfiniteScroll] Scroll trigger — loading more');
      this.loadMore();
    }
  }

  destroy() {
    console.log('[InfiniteScroll] destroy()');
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
      this.scrollHandler = null;
    }
    this.loading = false;
  }

  loadMore() {
    this.loading = true;
    if (this.spinner) this.spinner.style.display = 'block';

    const separator = this.nextUrl.includes('?') ? '&' : '?';
    const fetchUrl = `${this.nextUrl}${separator}section_id=${this.sectionId}`;
    console.log('[InfiniteScroll] Fetching:', fetchUrl);

    fetch(fetchUrl)
      .then((res) => {
        console.log('[InfiniteScroll] Fetch response status:', res.status);
        return res.text();
      })
      .then((html) => {
        console.log('[InfiniteScroll] Received HTML length:', html.length);
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll('#product-grid > li');
        const newSentinel = doc.getElementById('infinite-scroll-sentinel');

        console.log('[InfiniteScroll] New items found:', newItems.length);
        console.log('[InfiniteScroll] New sentinel found:', !!newSentinel, newSentinel ? newSentinel.dataset.nextUrl : 'n/a');

        newItems.forEach((item) => {
          this.grid.appendChild(item);
        });

        if (newSentinel && newSentinel.dataset.nextUrl) {
          this.nextUrl = newSentinel.dataset.nextUrl;
          this.sentinel.dataset.nextUrl = this.nextUrl;
          console.log('[InfiniteScroll] Updated nextUrl to:', this.nextUrl);
        } else {
          this.nextUrl = null;
          if (this.observer) this.observer.disconnect();
          if (this.scrollHandler) {
            window.removeEventListener('scroll', this.scrollHandler);
            this.scrollHandler = null;
          }
          if (this.sentinel) this.sentinel.remove();
          console.log('[InfiniteScroll] No more pages — done.');
        }

        if (this.spinner) this.spinner.style.display = 'none';
        this.loading = false;
      })
      .catch((err) => {
        console.error('[InfiniteScroll] Fetch error:', err);
        if (this.spinner) this.spinner.style.display = 'none';
        this.loading = false;
      });
  }
}

// Initialize when DOM is ready
console.log('[InfiniteScroll] Script loaded, readyState:', document.readyState);
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('[InfiniteScroll] DOMContentLoaded fired');
    new InfiniteScroll();
  });
} else {
  console.log('[InfiniteScroll] DOM already ready, initializing now');
  new InfiniteScroll();
}
